const $navbar = document.querySelector('.navbar'); // Used for offsetting against bottom of navbar

const scrollToTarget = target => {
	let $target = [];

	// check if var target is a selector or DOM element.
	if (target.nodeType) {
		$target.push(target);
	} else {
		$target = document.querySelectorAll(target);
	}

	$target.forEach($el => {
		const headerOffset = $navbar ? $navbar.clientHeight : 0;
		const elementPosition = $el.getBoundingClientRect().top;
		const offsetPosition = elementPosition + window.scrollY - headerOffset;
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	});
};

const init = () => {
	const $triggers = document.querySelectorAll('.js-scrollto');

	$triggers.forEach($el => {
		if ($el.hasAttribute('data-scrollto-target')) {
			const target = $el.getAttribute('data-scrollto-target');
			$el.addEventListener('click', e => {
				e.preventDefault();
				scrollToTarget(target);
			});
		}
	});
};

module.exports = init;
